import React, { useEffect, useRef } from "react";
import MidBox from "../../../../components/Boxes/MidBox";
import EmptyState from "../../../../components/EmptyState";
import CampBoxEmptyState from "./empty-state";
import useCamp from "../../../hooks/useCamp";
import classNames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import CircularProgress from "../../../../components/CircularProgress";
import { CloseArenaDialog } from "../../../../redux/arena-dialog/action";
import { useDispatch } from "react-redux";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";

type Props = {};

const CampBox = (props: Props) => {
  const { fetchTroops, playerTroops, isLoading, isMoveLoading, moveTroop } =
    useCamp();
  const { t } = useAppTranslation("battle");
  const isMounted = useRef(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isMounted.current) return;
    isMounted.current = true;
    fetchTroops();
  }, [fetchTroops]);
  const navigate = useNavigate();
  return (
    <MidBox
      className="w-100"
      secondaryTitle
      onTitleClick={() => {
        dispatch(CloseArenaDialog());
        navigate("/barracks?type=camp");
      }}
      noMargin
      containerClass="px-0 px-lg-4 "
      title={
        <div className="d-flex align-items-center gap-1">
          <img
            src="/assets/images/arena/icons/dart.png"
            width={40}
            className="mb-1"
            alt={t("dashboard.boxes.camp.title")}
          />
          {t("dashboard.boxes.camp.title")}
        </div>
      }
    >
      <div style={{ marginTop: -20 }} className="mx-3">
        <div
          style={{ minHeight: 200 }}
          className={classNames(
            "camp-box-content position-relative  bg-2 rounded-3  d-flex flex-column  p-3",
            {
              "justify-content-center align-items-center":
                !isLoading && playerTroops.length === 0,
            },
            { "align-items-center justify-content-center": isLoading }
          )}
        >
          {isLoading && <CircularProgress />}
          {!isLoading && playerTroops.length === 0 && <CampBoxEmptyState />}
          {!isLoading && playerTroops.length > 0 && (
            <div className="w-100 row ">
              {playerTroops.map((troop) => {
                return (
                  <div className="col-3 p-0" key={troop.id}>
                    <div className="troop-frame position-relative">
                      <div className="troop-level">{troop.level}</div>
                      <img
                        className="circle m-1 scaleX w-100 "
                        width={"100%"}
                        src={troop.troop.icon}
                        alt={troop.troop.name}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <Link
          onClick={() => dispatch(CloseArenaDialog())}
          className="w-100 text-center d-block"
          to="/barracks?type=camp"
        >
          <a className="dark-yellow mt-2 fs-small d-block font-normal ">
            {t("dashboard.actions.manageTroops")}
          </a>
        </Link>
      </div>
    </MidBox>
  );
};

export default CampBox;
